// src/components/Common/ToggleSwitch.js
import React from "react";

/**
 * A simple toggle switch that shows ON in green or OFF in gray.
 * @param {boolean} checked - Whether the switch is ON (true) or OFF (false).
 * @param {function} onChange - Callback when the switch is toggled; receives the new boolean value.
 */
function ToggleSwitch({ checked, onChange }) {
  return (
    <div
      className={`relative inline-flex h-5 w-12 items-center rounded-full cursor-pointer transition-colors 
        ${checked ? "bg-green-500" : "bg-gray-500"}`}
      onClick={() => onChange(!checked)}
    >
      {/* The round indicator */}
      <div
        className={`absolute h-3 w-3 rounded-full bg-white transform transition-transform 
          ${checked ? "translate-x-6" : "translate-x-1"}`}
      />
      {/* ON label (only visible if checked) */}
      {checked && (
        <span className="absolute left-1 text-xs font-small text-white">
          ON
        </span>
      )}
      {/* OFF label (only visible if !checked) */}
      {!checked && (
        <span className="absolute right-1 text-xs font-small text-white">
          OFF
        </span>
      )}
    </div>
  );
}

export default ToggleSwitch;
